export const filterRequestStrings = (data: Record<string, any>) => {
  if (data) {
    Object.keys(data).forEach((key) => {
      if (data[key] === '' || data[key] === 'null') {
        data[key] = null;
      }
    });
  }
};
